<div
  class="app-custom-dropdown"
  [class.app-custom-dropdown--open]="panelOpen"
  [class.app-custom-dropdown--disabled]="disabled"
>
  <button
    #triggerBtn
    type="button"
    class="cdd-trigger"
    [class.cdd-trigger--status]="variant === 'status'"
    [class.cdd-trigger--plain]="variant === 'plain'"
    [ngStyle]="
      variant === 'status'
        ? triggerPillStyle
        : triggerPlainStyle
    "
    [disabled]="disabled"
    (click)="toggle($event)"
    [attr.aria-expanded]="panelOpen"
  >
    <span class="cdd-label">
      {{ label }}
    </span>

    <span class="cdd-chevron"></span>
  </button>

  <div
    *ngIf="panelOpen"
    #panelRef
    class="cdd-panel"
    (click)="$event.stopPropagation()"
    role="listbox"
  >
    <button
      *ngFor="let option of options"
      type="button"
      class="cdd-row"
      [class.cdd-row--active]="option.value === value"
      (click)="select(option, $event)"
      role="option"
      [attr.aria-selected]="option.value === value"
    >
      <span
        class="cdd-radio"
        [class.cdd-radio--active]="option.value === value"
      ></span>

      <span class="cdd-option-label">
        {{ option.label }}
      </span>
    </button>
  </div>
</div>